import { ArrowRight, ArrowLeft } from 'lucide-react';

interface ArrowIconProps {
  direction?: 'right' | 'left';
  variant?: 'long' | 'short';
  size?: number;
  style?: React.CSSProperties;
}

export default function ArrowIcon({
  direction = 'right',
  variant = 'long',
  size,
  style,
}: ArrowIconProps) {
  if (variant === 'short') {
    const shortSize = size ?? 14;
    const Icon = direction === 'left' ? ArrowLeft : ArrowRight;
    return <Icon size={shortSize} style={{ flexShrink: 0, ...style }} aria-hidden="true" />;
  }

  /* long luxury arrow — inherits currentColor */
  const longW = size ?? 36;
  const flip = direction === 'left';
  return (
    <svg
      width={longW}
      height={longW * 0.3}
      viewBox="0 0 40 12"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0, ...(flip ? { transform: 'scaleX(-1)' } : {}), ...style }}
    >
      <path
        d="M0 6H37M32 1.5L38 6L32 10.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
